import React, { useState, useEffect } from 'react';
import { ExercisesMetricsWidgetAverageAccess } from './exercises-metrics-widget-average-access';
import { ExercisesMetricsCardKpi } from './exercises-metrics-card-kpi';
import toast from 'react-hot-toast';
import { useClient } from 'jsonapi-react';
import { ExercisesMetricsWidgetPerformance } from './exercises-metrics-widget-performance';
import { useTranslation } from 'react-i18next';
import { ButtonGroup } from '@/components/ui/button-group';
import { Button } from '@/components/ui/button';
import { WidgetWrapper } from '@/components/custom/widget';
import { KpiWrapper } from '@/components/custom/kpi';

export function ExercisesMetrics() {
  const { t } = useTranslation();
  const [timeFilterSelected, setTimeFilterSeleted] = useState(0);
  const [metrics, setMetrics] = useState([]);
  const client = useClient();
  const btnGroup = [
    {
      id: 'hoje-engajamento',
      timeFilter: 0,
      label: t('questionBooks.today')
    },
    {
      id: 'ultima-semana-engajamento',
      timeFilter: 1,
      label: t('questionBooks.weekCurrent')
    },
    {
      id: 'ultimo-mes-engajamento',
      timeFilter: 4,
      label: t('questionBooks.monthLast')
    },
    {
      id: 'tres-meses-engajamento',
      timeFilter: 12,
      label: t('questionBooks.monthThree')
    }
  ];

  async function getMetrics(week) {
    const { data, error } = await client.fetch(`reports/question_books/metrics${week === 0 ? '' : `?week=${week}`}`);

    if (error) {
      toast.error(t('toast.errorGetCard'));
    } else {
      setMetrics(data);
    }
  }

  useEffect(() => {
    getMetrics(timeFilterSelected);
  }, [timeFilterSelected]);

  return (
    <div className="animate-fade-in">
      <ButtonGroup className="mb-4">
        {btnGroup.map(btn => {
          const isActive = timeFilterSelected === btn.timeFilter;

          return (
            <Button
              key={btn.id}
              variant={isActive ? 'default' : 'outline'}
              size="sm"
              onClick={() => setTimeFilterSeleted(btn.timeFilter)}
              aria-pressed={isActive}
            >
              {btn.label}
            </Button>
          );
        })}
      </ButtonGroup>

      <WidgetWrapper>
        <KpiWrapper>
          {metrics?.map(metric => (
            <ExercisesMetricsCardKpi
              key={metric?.id}
              cardIcon={metric?.icon}
              cardTitle={metric?.label}
              cardValue={metric?.value}
              cardPercentage={metric?.percent}
              cardPeriod={metric?.period}
            />
          ))}
        </KpiWrapper>
      </WidgetWrapper>

      <WidgetWrapper>
        <ExercisesMetricsWidgetPerformance timeFilterSelected={timeFilterSelected} />
      </WidgetWrapper>

      <WidgetWrapper>
        <ExercisesMetricsWidgetAverageAccess
          title={t('questionBooks.answeringAverageTime')}
          timeFilterSelected={timeFilterSelected}
        />
      </WidgetWrapper>
    </div>
  );
}
